module.exports = __webpack_public_path__ + "static/media/gt.58f35af6.svg";